import { render, staticRenderFns } from "./Functionality.vue?vue&type=template&id=cd20cd48&scoped=true&lang=pug"
import script from "./Functionality.vue?vue&type=script&lang=js"
export * from "./Functionality.vue?vue&type=script&lang=js"
import style0 from "./Functionality.vue?vue&type=style&index=0&id=cd20cd48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd20cd48",
  null
  
)

export default component.exports